export type CreateCommentRequest = {
    text: string;
    progressStatus?: string;
    type: CommentType;
}

export enum CommentType {
    Comment = 0,
    ProgressNote = 1
}